module.exports = __webpack_public_path__ + "img/img_none_english.133e8e68.png";